import type { ResourcesConfig } from 'aws-amplify';
import env from '@/configs/env';

export const cognitoConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: env.cognitoUserPoolId,
      userPoolClientId: env.cognitoClientId,
      loginWith: {
        oauth: {
          domain: env.cognitoDomain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [env.cognitoRedirectSignIn],
          redirectSignOut: [env.cognitoRedirectSignOut],
          responseType: 'code',
        },
      },
    },
  },
};
